/* src/app/main-layout/components/user-info/user-info.component.css */
@layer properties;
.avatar {
  margin-inline-end: calc(var(--spacing, 0.25rem) * 2.5);
}
@media (width >= 40rem) {
  .avatar {
    margin-inline-end: calc(var(--spacing, 0.25rem) * 3.5);
  }
}
.name {
  display: none;
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
}
@media (width >= 40rem) {
  .name {
    display: flex;
  }
}
.user-info {
  display: flex;
  align-items: center;
}
@property --tw-font-weight { syntax: "*"; inherits: false; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-font-weight: initial;
    }
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=user-info.component.css.map */
